import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Grid, Dropdown, Button, Icon} from 'semantic-ui-react';
import TimerCurrentDate from '../../../common/components/timerCurrentDate';
import {months} from '../../../common/constants/months';
import {paths} from '../../../common/dictionaries/urls';
import {getSystemParameterValue} from '../../../common/util/parametersUtils';
import BarChartByDays from './chart/bar';
import LiquidationsByDaysDetail from './table';
import moment from 'moment';
import './kpiByDays.scss';

let timer = null;
const date = new Date();
const currentYear = parseInt(moment(date).format('YYYY'), 10);
const currentMonth = parseInt(moment(date).format('MM'), 10);
const liquidationsTypes = [
  {'text': 'Terceros', 'value': 'TERCEROS'},
  {'text': 'Normal', 'value': 'NORMAL'},
];

class KpiLiquidationsByDays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'yearTmp': currentYear,
      'yearSelected': currentYear,
      'monthTmp': currentMonth,
      'monthSelected': currentMonth,
      'typeTmp': liquidationsTypes[0].value,
      'typeSelected': liquidationsTypes[0].value,
      'daySelected': '',
      'transactionTypeSelected': '',
      'showDetail': false,
      'importationsRefreshTime': getSystemParameterValue(props.systemParameters,
        'INTERVAL_REFRESH_IMPORTATIONS') || 60,
    };
  }

  componentDidMount() {
    this.startTimer();
  }

  startTimer() {
    const {importationsRefreshTime} = this.state;
    const {typeSelected, yearSelected, monthSelected} = this.state;
    this.props.fetchLiquidationsByDays(typeSelected, yearSelected, monthSelected);

    timer = setInterval(() => {
      this.props.fetchLiquidationsByDays(typeSelected, yearSelected, monthSelected);
    }, importationsRefreshTime * 1000);
  }

  componentDidUpdate(prevProps) {
    const {systemParameters} = this.props;
    const {importationsRefreshTime} = this.state;
    
    if (prevProps.systemParameters !== systemParameters) {
      const interval = getSystemParameterValue(systemParameters, 'INTERVAL_REFRESH_IMPORTATIONS');
      if (interval && interval !== importationsRefreshTime) {
        this.stopTimer();
        this.setState({'importationsRefreshTime': interval}, () => this.startTimer());
      }
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  stopTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }

  goToHome() {
    this.props.push(paths.Home);
  }

  getYears() {
    const years = [];
    const initialYear = 2014;
    const numberOfYears = currentYear - initialYear;
    for (let i = 0; i <= numberOfYears; i++) {
      years.push(initialYear + i);
    }

    return Object.keys(years).map((position) => {
      const year = years[position];
      return {'text': year, 'value': year};
    });
  }

  changeYear(value) {
    this.setState({'yearTmp': value});
    this.updateDataForYear(value);
  }

  updateDataForYear(newYear) {
    const {yearSelected, monthSelected} = this.state;
    if (yearSelected === newYear) {
      return;
    }

    const newState = {
      'yearSelected': newYear,
    };

    if (newYear === currentYear && monthSelected > currentMonth) {
      newState.monthTmp = currentMonth;
      newState.monthSelected = currentMonth;
    }
    this.setState(newState, () => this.onSearchClick());
  }

  getMonths() {
    const {yearSelected} = this.state;
    return Object.keys(months).map((month) => {
      const isMonthDisabled = currentYear === yearSelected && months[month] > currentMonth;
      return {'text': month, 'value': months[month], 'disabled': isMonthDisabled};
    });
  }

  changeMonth(value) {
    this.setState({'monthTmp': value});
    this.updateDataForMonth(value);
  }

  updateDataForMonth(newMonth) {
    const {monthSelected} = this.state;
    if (monthSelected === newMonth) {
      return;
    }
    this.setState({
      'monthSelected': newMonth,
      'showData': false,
    }, () => this.onSearchClick());
  }

  changeType(value) {
    this.setState({'typeTmp': value});
    this.updateDataForType(value);
  }

  updateDataForType(newType) {
    const {typeSelected} = this.state;
    if (typeSelected === newType) {
      return;
    }
    this.setState({
      'typeSelected': newType,
    }, () => this.onSearchClick());
  }

  render() {
    const {yearTmp, monthTmp, typeTmp} = this.state;
    const {loading} = this.props;

    return (
      <div className='liquidations-by-days-page'>
        <div className='title-bar'>
          <div className='title'>
            <Icon link name={'home'} color='red' size='big'
              onClick={this.goToHome.bind(this)} />
            <h2>Liquidados vs Facturados</h2>
            <div className='title-bar-actions'>
              <TimerCurrentDate />
            </div>
          </div>
          <div className='filters-section'>
            <Grid textAlign='left'>
              <Grid.Row>
                <Grid.Column width={1} className='order-label'>
                  <h4>Año</h4>
                </Grid.Column>
                <Grid.Column width={2}>
                  <Dropdown selection
                    options={this.getYears()}
                    search
                    value={yearTmp}
                    disabled={loading}
                    loading={loading}
                    onChange={(e, {value}) => this.changeYear(value)}
                    placeholder='Año'
                    noResultsMessage='Año no encontrado'
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  <h4>Mes</h4>
                </Grid.Column>
                <Grid.Column width={2}>
                  <Dropdown selection
                    options={this.getMonths()}
                    search
                    value={monthTmp}
                    onChange={(e, {value}) => this.changeMonth(value)}
                    placeholder='Mes'
                    noResultsMessage='Mes no encontrado'
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  <h4>Tipo</h4>
                </Grid.Column>
                <Grid.Column width={2}>
                  <Dropdown selection
                    options={liquidationsTypes}
                    search
                    value={typeTmp}
                    onChange={(e, {value}) => this.changeType(value)}
                    placeholder='Tipo'
                  />
                </Grid.Column>
                <Grid.Column width={7} textAlign='right'>
                  {this.renderClearButton()}
                  {this.renderSearchButton()}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </div>

        <BarChartByDays onClickDaySelected={this.onDaySelected.bind(this)} />

        {this.renderDetail()}
      </div>
    );
  }
  renderClearButton() {
    const {loading} = this.props;
    return (
      <Button
        type='button'
        secondary
        className='toyota-primary'
        disabled={loading}
        loading={loading}
        onClick={this.onClearClick.bind(this)}
      >
        Limpiar
      </Button>
    );
  }

  onClearClick() {
    this.setState({
      'yearTmp': currentYear,
      'yearSelected': currentYear,
      'monthTmp': currentMonth,
      'monthSelected': currentMonth,
      'typeTmp': liquidationsTypes[0].value,
      'typeSelected': liquidationsTypes[0].value,
      'daySelected': '',
      'transactionTypeSelected': '',
      'showDetail': false,
    }, () => this.onSearchClick());
  }

  renderSearchButton() {
    const {loading} = this.props;
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        disabled={loading}
        loading={loading}
        onClick={this.onSearchClick.bind(this)}
      >
        Buscar
      </Button>
    );
  }

  onSearchClick() {
    this.stopTimer();
    this.setState({
      'daySelected': '',
      'transactionTypeSelected': '',
      'showDetail': false,
    }, () => this.startTimer());
  }

  onDaySelected(day, type) {
    this.setState({
      'daySelected': day,
      'transactionTypeSelected': type,
      'showDetail': true,
    }, () => this.onSearchDetail());
  }

  onSearchDetail() {
    const {typeSelected, yearSelected, monthSelected, daySelected} = this.state;
    const filters = {
      'type': typeSelected,
      'year': yearSelected,
      'month': monthSelected,
      'day': daySelected,
    };
    this.props.fetchLiquidationsByDaysDetail(filters);
  }

  renderDetail() {
    const {showDetail, transactionTypeSelected} = this.state;
    if (!showDetail) {
      return null;
    }
    
    return <LiquidationsByDaysDetail transactionType={transactionTypeSelected} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'systemParameters': state.parameters.list,
  };
};

const {
  fetchLiquidationsByDays,
  fetchLiquidationsByDaysDetail,
} = Actions;

export default connect(mapStateToProps, {
  fetchLiquidationsByDays,
  fetchLiquidationsByDaysDetail,
})(KpiLiquidationsByDays);
